import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  title: 'Kit Anticaos de Clase',
  subtitle: 'Checklist express para tener todo listo en 5 min',
  value: '$19',
  img: 'https://cdn.magicpatterns.com/uploads/uJZTwM9CnAz4EWmG4Z8wth/12123bd2-95ff-4287-ac8f-b49d3b2fef84-mockup.webp'
}, {
  num: '2',
  title: 'Mapas de Rotación Grupal',
  subtitle: 'Cómo organizar de 2 a 6 alumnos sin que nadie se pare',
  value: '$37',
  img: 'https://cdn.magicpatterns.com/uploads/acgP2DkaCSjCoBJ7XdUzQb/1ca3b53f-de79-4747-9ba6-d18b63a945eb-mockup.webp'
}, {
  num: '3',
  title: '75 Frases de Corrección Rápida',
  subtitle: 'Qué decir en el momento justo para mejorar al alumno',
  value: '$27',
  img: 'https://cdn.magicpatterns.com/uploads/rdkrMFH9ptSjfhy4nB84un/645a6000-9fb7-4bc2-9387-dc9a3a9ff6b7-mockup.webp'
}, {
  num: '4',
  title: 'Mini Informes de Progreso',
  subtitle: 'Dale feedback profesional a tus alumnos en PDF',
  value: '$20',
  img: 'https://cdn.magicpatterns.com/uploads/amGXng4odNGxqkVgevFk6j/abc07307-cb4a-440f-88ee-d6ff57259c93-mockup.webp'
}, {
  num: '5',
  title: 'Plan B de Emergencia',
  subtitle: '25 soluciones para cuando falta gente, llueve o sobra gente',
  value: '$37',
  img: 'https://cdn.magicpatterns.com/uploads/jrLLUpxdCXLW58f7nGZeVN/74673268-75bc-428b-9176-cb6c830ebfd8-mockup.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-13">
            🎁 5 Bonos Exclusivos
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-14">
            Valorados en{' '}
            <span className="line-through text-secondary" data-id="element-15">$140 USD</span> —
            Incluidos <span className="font-bold text-primary" data-id="element-16">GRATIS</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light flex flex-col shadow-sm overflow-hidden transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-18">
              <div className="relative aspect-square bg-bg-main overflow-hidden" data-id="element-19">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-20" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center font-serif font-black text-lg shadow-md" data-id="element-21">
                  {bonus.num}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-22">
                <p className="text-text-sec text-xs font-bold uppercase tracking-wider mb-1" data-id="element-23">
                  Bono {bonus.num}
                </p>
                <h3 className="text-text-main font-bold text-lg leading-tight mb-1" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm leading-snug mb-3 flex-1" data-id="element-25">
                  {bonus.subtitle}
                </p>
                <div className="flex items-center gap-2 text-base" data-id="element-26">
                  <span className="text-secondary line-through font-medium" data-id="element-27">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-28">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}